import { useEffect, useRef, useState, useMemo } from "react";
import { Box, Button, Grid, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Pagination } from "../../Pagination";
import './manualBackupConfig.css';
import _ from "lodash";
import { backupConfigData, inventoryDownloadConfig, clearInventoryConfigDownload, getInventoryWarehouseVesselList, deleteManualBackupConfig, createShareConfigData, getSharedConfigPerConfigData, updateSharedConfigData, deleteSharedConfigData } from "../../../actions/Users/authenticateInventory";
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI, getParentAndSubDpIds } from "../../../utils/util";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../../utils/constants";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import ascSortingSelected from "../../../asset/image/ascSortingSelected.svg";
import descSortingSelected from "../../../asset/image/descSortingSelected.svg";
import AscSort from "../../../asset/image/AscSort.svg";
import DescSort from "../../../asset/image/DescSort.svg";
import { toast } from "react-toastify";
import { CONFIRM_DIALOG_TITLE, SERVICE_FUNCTION_TO_FEATURE } from "../../../config";
import DeleteIcon from "../../../asset/image/user_delete.svg";
import ConfirmDialog from "../../ConfirmDialog";

import Download from '../../../asset/image/DownloadUsage.svg';
import { CsvParameters, downloadAsCSV } from "../../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../../DownloadCSV";
import { CREATE_SHARE_CONFIG, GET_CSV_DATA_TO_DOWNLOAD, GET_SHARED_CONFIG_PER_CONFIG, UPDATE_SHARED_CONFIG, DELETE_SHARED_CONFIG } from "../../../actions/types";
import ShareIcon from '@mui/icons-material/Share';
import AddEditInterfaceModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/AddEditInterfaceModal";
import Org_Drop_down from "../../SubscriptionReports/Org_Drop_down";
import LabelValueDisplay from "../../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay";
import CustomLoader from "../../Loader/CustomLoader";
import edit from '../../../asset/image/edit.png';

const convertToCsv = (data: any[][], userTimezone: string) => {
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        csvRows.push([row?.['config_name'], row?.['site_name'], row?.['device_id'], row?.['software_version'], convertDateTimeIntoTimezone(row?.['create_time'], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), row?.['user'], row?.['status']])
    })
    let creationTime = 'Creation Time (' + userTimezone + ')'
    return [['Config Name', 'Site', 'DID', 'EOS Version', creationTime, 'Initiated By', 'Status'], ...csvRows]
}

const ManualBackupConfig = (props) => {
    const { authReducer, backupConfigData, setBackupConfigDataLoading, inventoryDownloadConfig, clearInventoryConfigDownload, getInventoryWarehouseVesselList, deleteManualBackupConfig, history, location, downloadAsCSV, isReadOnlyUser, createShareConfigData, createShareConfig, setCreateShareConfigLoading, getSharedConfigPerConfigData, getSharedConfigPerConfig, setSharedConfigPerConfigLoading, updateSharedConfigData, getUpdateSharedConfig, setUpdateSharedConfigLoading, deleteSharedConfigData, getDeleteSharedConfig, setDeleteSharedConfigLoading, selectedOrg } = props;
    let _q = getDecodeURI(location?.search);
    const MANUAL_BACKUP_CONFIG = "manual-backup-config"
    // filterAppliedOn - will be available if filter is applied on manual backup config table
    // on PAGE REFRESH dont consider URL filter keys, fetch data using default filters
    if (!(_q.hasOwnProperty("filterAppliedOn") && _q.filterAppliedOn == MANUAL_BACKUP_CONFIG)) {
        _q = {}
    }
    const DEFAULT_PAGE_SIZE = 15;
    const [k4Ids, setK4ids] = useState('');
    const [page, setPage] = useState(_q.hasOwnProperty('page') ? parseInt(_q.page) : 1);
    const [limit, setLimit] = useState(_q.hasOwnProperty('limit') ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
    const [backupTableData, setBackupTableData] = useState<any>([]);
    const ENTER_KEY_CODE = "Enter";
    const [searchValue, setSearchValue] = useState<any>(_q.hasOwnProperty("search") ? _q.search : "");
    const [isSearchApplied, setISearchApplied] = useState<Boolean>(searchValue ? true : false);
    const NAME = 'config_name';
    const ORG = 'ou_name';
    const SITE_NAME = 'site_name';
    const DEVICE_ID = 'device_id';
    const SOFTWARE_VERSION = 'software_version';
    const CREATE_TIME = 'create_time';
    const STATUS = 'status';
    const USER = 'user';
    const ASC_ORDER = "asc";
    const DESC_ORDER = "desc"; 
    const [sort, setSort] = useState<any>(_q.hasOwnProperty("sort") ? _q.sort : CREATE_TIME);
    const [sortOrder, setSortOrder] = useState<any>(_q.hasOwnProperty("sortOrder") ? _q.sortOrder : DESC_ORDER);
    const [totalCount, setTotalCount] = useState(0);
    const [downloadConfig, setDownloadConfig] = useState(false);
    // show only manual backups
    const IS_MANUAL_BACKUP = true;
    const VIEW_INVENTORY = "view-inventory";
    const viewDeployedService = SERVICE_FUNCTION_TO_FEATURE[VIEW_INVENTORY]['service'];
    const viewDeployedFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_INVENTORY]['function'];
    const searchTimeoutRef = useRef<any>();
    const intervalRef = useRef<any>();
    const dispatch = useDispatch();
    const [shareConfigDialog, setShareConfigDialog] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState<any>(null);
    const [selectedOu, setSelectedOu] = useState<any>([]);
    const [customName, setCustomName] = useState<string>('');
    const [actionType, setActionType] = useState<string>('Edit');
    const [originalCustomName, setOriginalCustomName] = useState<string>('');
    const [originalSelectedOu, setOriginalSelectedOu] = useState<any>([]);
    const userOu = JSON.parse((localStorage.getItem('user_ou'))?.toString() || '')
    const [tempState, setTempState] = useState<any>([userOu?.name]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [alreadySharedOuIds, setAlreadySharedOuIds] = useState<string[]>([]);

    const isReportEdit = useMemo(() => ({ org_names: tempState || [userOu?.name], orgs_id: selectedOu || [userOu?.id] }), [tempState, selectedOu]);
    const orgDropdownKey = isDataLoaded ? `loaded-${alreadySharedOuIds.length}-${(tempState || [userOu?.name]).join('-')}` : 'unloaded';

    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "" as string | JSX.Element,
        onConfirm: {},
    });

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'manual-config') {
                DownloadCSV(convertToCsv(authReducer.csvDataDownloded, authReducer.userTimezone)
                    , {
                        formatters: {
                            0: 'ESC-COMMA',
                            1: 'ESC-COMMA',
                            4: 'ESC-COMMA'
                        }
                    }
                );
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])

    useEffect(() => {
        if (!_.isEmpty(authReducer.getVesselsListing) && !_.isEmpty(selectedOrg)) {
            // const sites = authReducer?.getVesselsListing?.hasOwnProperty("locations") ? authReducer?.getVesselsListing?.locations : [];
            let Vessels = [];
            const filteredVessels = authReducer?.filteredVessels;
            if (filteredVessels && filteredVessels.length > 0) {
                Vessels = filteredVessels;
            } else {
                Vessels = authReducer?.getVesselsListing?.locations;
            }
            if (Vessels?.length == 0) {
                setBackupTableData([]);
                setPage(0);
                setLimit(0);
                setTotalCount(0);
                return;
            }
            const k4Ids = Vessels && Vessels.length > 0 ? `${Vessels.map((item: any) => item.id).join(",")}` : '';
            setK4ids(k4Ids);
            const Page = 1;
            setPage(1);
            setLimit(_q.hasOwnProperty('limit') ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
            k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, Page, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
        }
    }, [authReducer.getVesselsListing, authReducer?.filteredVessels, selectedOrg])

    useEffect(() => {
        if (!_.isEmpty(authReducer.backupConfigData)) {
            const data = authReducer?.backupConfigData?.result;
            setBackupTableData(data);
            setTotalCount(authReducer?.backupConfigData?.result_info?.total_count);
            authReducer.backupConfigData = {}
        }
    }, [authReducer.backupConfigData])

    useEffect(() => {
        if (!_.isEmpty(authReducer.deleteManualBackupConfig)) {
            console.log(authReducer.deleteManualBackupConfig)
            k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, page, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
            authReducer.deleteManualBackupConfig = {}
        }
    }, [authReducer.deleteManualBackupConfig])

    useEffect(() => {
        const hasInProgressConfig = backupTableData?.some(row => row?.status === 'inprogress');
        
        if (hasInProgressConfig && k4Ids) {
            intervalRef.current = setInterval(() => {
                !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, page, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
            }, 30000);
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }
        
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [backupTableData]);

    const rowsOption = [10, 15, 25, 50, 100]

    const handleChangePage = (e, value) => {
        let params: any = getDecodeURI(location?.search);
        params.page = value;
        setPage(value);
        params.filterAppliedOn = MANUAL_BACKUP_CONFIG
        doNavigate(params);
        k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, value, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
    }

    const handleChangeRowsPerPage = (e) => {
        const Limit = parseInt(e.target.value);
        const Page = 1;
        let params: any = getDecodeURI(location?.search);
        params.page = 1;
        params.limit = Limit;
        setPage(1);
        setLimit(Limit);
        params.filterAppliedOn = MANUAL_BACKUP_CONFIG
        doNavigate(params);
        k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, Page, Limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
    }

    const doNavigate = (params) => {
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const searchBoxKeyDown = (event: any) => {
        if (event && event.key === ENTER_KEY_CODE) {
            doSearch(searchValue);
        }
    }

    const doSearch = (value: string) => {
        let params: any = getDecodeURI(location?.search);
        params.search = value;
        delete params.page;
        const Page = 1;
        setPage(1);
        setISearchApplied(true);
        params.filterAppliedOn = MANUAL_BACKUP_CONFIG
        doNavigate(params);
        k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, Page, limit, value, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
    };

    const closeSearch = () => {
        setSearchValue("");
        let params: any = getDecodeURI(location?.search);
        delete params.search;
        delete params.page;
        delete params.filterAppliedOn
        const Page = 1;
        setPage(1);
        doNavigate(params);
        setISearchApplied(false);
        k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, Page, limit, '', sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
    }

    const Sorting = (field, order) => {
        let params: any = getDecodeURI(location?.search);
        delete params.page;
        params.sort = field;
        params.sortOrder = order;
        const Page = 1;
        setPage(1);
        setSort(field);
        setSortOrder(order);
        params.filterAppliedOn = MANUAL_BACKUP_CONFIG
        doNavigate(params);
        k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, Page, limit, searchValue, field, order, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
    }

    const setSorting = (event: any, field: any, order: any,) => {
        if (event && event.currentTarget) {
            Sorting(field, order);
        }
    };

    const switchSorting = (event: any, field: any) => {
        let order = ASC_ORDER;
        if (sort === field) {
            order = ASC_ORDER === sortOrder ? DESC_ORDER : ASC_ORDER;
        }
        Sorting(field, order);
    };

    useEffect(() => {
        if (!_.isEmpty(authReducer.inventoryDownloadConfig) && downloadConfig) {
            const url = authReducer?.inventoryDownloadConfig?.result;

            if (authReducer?.inventoryDownloadConfig?.success == true) {
                window.open(url);
                clearInventoryConfigDownload();
            } else if (!authReducer?.inventoryDownloadConfig?.success || authReducer?.inventoryDownloadConfig?.data?.success == false) {
                toast.error('Something went wrong, unable to download the file..', {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
            }
            authReducer.inventoryDownloadConfig = {};
        }
    }, [authReducer?.inventoryDownloadConfig])

    const handleDOwnloadConfig = (row) => {
        setDownloadConfig(true);
        const siteId = row?.site_id;
        const deviceId = row?.device_id;
        const configId = row?.id
        inventoryDownloadConfig(siteId, deviceId, configId)
    }

    const DeleteManualBackipConfig = (row) => {
        deleteManualBackupConfig(row.site_id, row.device_id, row.id, row.config_name)
    }

    const handleOnSearchClick = () => {
        doSearch(searchValue);
    }

    const handleOnSearchClear = () => {
        setSearchValue('');
        doSearch('');
    }
    
    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchValue(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            doSearch(e.target.value);
        }, 1000)
    }

    const handleDownloadReport = () => {
        if (k4Ids.length === 0) {
            toast.error("No data available to download", {
              position: toast.POSITION.BOTTOM_LEFT,
            })
            return;
          }
        const params: CsvParameters = {
            type: "POST_API",
            id: "manual-config",
            endpoint: `/edge/sites/devices/configuration/pg/query`,
            payload: {
                "site_id": k4Ids,
                "device_id": '',
                "device_type": '',
                "manual": true,
                "search": searchValue,
                "page": 0,
                "size": totalCount,
                "sort_by": sort,
                "sort_order": sortOrder,
                "software_version": '',
                "ou_ids": getParentAndSubDpIds(userOu?.id, authReducer?.parentDpAndSubDpList)
            }
        }
        downloadAsCSV(params);
    }

    const handleOu = (ou: any) => {
        setSelectedOu(ou);
    };


    const hanldeSaveShareConfig = () => {
        const payload: any = {
            user_ou_id: userOu?.id,
        };

        if (!_.isEqual(selectedOu, originalSelectedOu)) {
            payload.ou_ids = selectedOu;
        }

        if (customName !== originalCustomName) {
            payload.custom_name = customName;
        }

        if (actionType === 'Edit') {
            updateSharedConfigData(selectedConfig?.id, {
                custom_name: payload.custom_name,
                ou_id: selectedOrg?.id,
                share_id: selectedConfig?.share_id
            });
        } else {
            createShareConfigData(selectedConfig?.id, {
                user_ou_id: userOu?.id,
                ou_ids: selectedOu,
                custom_name: customName
            });
        }
    }

    const handleSaveDisabled = () => {
        if (actionType === 'Edit') {
            return !customName || customName === originalCustomName;
        }

        if (actionType === 'Share') {
            if (!customName) return true;
            const newOrgs = (selectedOu || []).filter(id => id !== userOu?.id && id !== selectedConfig?.ou_id);
            return newOrgs.length === 0;
        }

        if (actionType === 'Edit') {
            const origName = originalCustomName || selectedConfig?.config_name;
            const customNameChanged = customName !== origName;
            const ouIdsChanged = !_.isEqual([...selectedOu].sort(), [...originalSelectedOu].sort());
            return !customNameChanged && !ouIdsChanged;
        }

        return true;
    }

    useEffect(() => {
        if (!_.isEmpty(createShareConfig) && createShareConfig?.success) {
            setShareConfigDialog(false);
            toast.success(createShareConfig?.result, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setCustomName('');
            dispatch({type: CREATE_SHARE_CONFIG, payload: {}});
            k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, 1, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
        }
        if (!_.isEmpty(getUpdateSharedConfig) && getUpdateSharedConfig?.success) {
            setShareConfigDialog(false);
            toast.success(getUpdateSharedConfig?.result, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setCustomName('');
            dispatch({type: UPDATE_SHARED_CONFIG, payload: {}})
            k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, 1, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
        }
        if(!_.isEmpty(getDeleteSharedConfig) && getDeleteSharedConfig?.success) {
            setShareConfigDialog(false);
            toast.success(getDeleteSharedConfig?.result, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setCustomName('');
            dispatch({type: DELETE_SHARED_CONFIG, payload: {}})
            k4Ids && !_.isEmpty(selectedOrg) && backupConfigData(k4Ids, 1, limit, searchValue, sort, sortOrder, '', '', '', IS_MANUAL_BACKUP, "", selectedOrg?.id);
        }
    }, [createShareConfig, getUpdateSharedConfig, getDeleteSharedConfig]);

    const clickConfigShareIcon = (row, action) => {
        setIsDataLoaded(false);
        setSelectedConfig(row);
        setShareConfigDialog(true);
        setSelectedOu([]);
        setCustomName(row?.config_name);
        if(action == 'share') {
            setAlreadySharedOuIds(row?.ou_id ? [row.ou_id] : []);
            const dpIds = getParentAndSubDpIds(userOu?.id, authReducer?.parentDpAndSubDpList);
            getSharedConfigPerConfigData(row?.id, dpIds);
            setActionType('Share');
            setTempState([authReducer?.getOrganisationUnitList?.dps[0]?.name]);
            setIsDataLoaded(true);
        } else {
            setAlreadySharedOuIds([]);
            setActionType('Edit');
            setOriginalCustomName(row?.config_name);
            if (row?.is_shared) {
                setIsDataLoaded(true);
            }
        }
    }

    useEffect(() => {
        if (!_.isEmpty(getSharedConfigPerConfig)) {
            const data = getSharedConfigPerConfig?.data;
            if (Array.isArray(data) && data.length > 0) {
                setAlreadySharedOuIds(prev => Array.from(new Set([...prev, ...data.map(item => item.ou_id).filter(Boolean)])));
            }
            dispatch({type: GET_SHARED_CONFIG_PER_CONFIG, payload: {}})
        }
    }, [getSharedConfigPerConfig]);

    return (
        <div className="backup-config-container">
            <Grid container spacing={0.5} className="inventoryCMContainer alertsFilterContainer">
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} className="inventoryCMHeading">Backup Configuration</Grid>
                    
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} className="alertsFilterContainerBox alignTopbarItemsCenter">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Box className="searchbarBox">
                            {<TextField
                                id="outlined-basic"
                                variant="outlined"
                                placeholder="Type something"
                                autoComplete="off"
                                size="small"
                                value={searchValue}
                                onChange={handleOnSearchChange}
                                onKeyDown={(event) => searchBoxKeyDown(event)}
                                InputLabelProps={{ className: "serachLabel" }}
                                InputProps={{
                                    className: "searchbarInputs",
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            {!searchValue && <SearchIcon
                                                className="searchbarIconsPosition"
                                                onClick={handleOnSearchClick}
                                            />}
                                            {searchValue && <CloseIcon
                                                className="searchbarIconsPosition"
                                                onClick={handleOnSearchClear}
                                            />}
                                        </InputAdornment>
                                    ),
                                }}
                            />}
                        </Box>
                    </Grid>
                    {totalCount > 0 && <Grid item xs={6} sm={6} md={6} lg={6} className="sim-anal-csv">
                        <div className="download-summary-btn marg-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>
                    </Grid>}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersConatiner">
                <Paper className="pagination-position config-pagination">
                        <Pagination
                            rowsPerPageOptions={rowsOption}
                            count={totalCount}
                            rowsPerPage={limit}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                    <TableContainer className="usageReports-FleetDashboard backup-config-table-container manual-backup-table">
                        <Table aria-label="simple sticky table" stickyHeader>
                            <TableHead className="usageReports-tableHead">
                                <TableRow className="UsageReports-tableRow config-tableRow">
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, NAME)}>Config Name</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === NAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, NAME, ASC_ORDER)} />
                                                <img src={sort === NAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, NAME, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, ORG)}>Organization</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === ORG && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, ORG, ASC_ORDER)} />
                                                <img src={sort === ORG && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, ORG, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, SITE_NAME)}>Site</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === SITE_NAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, SITE_NAME, ASC_ORDER)} />
                                                <img src={sort === SITE_NAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, SITE_NAME, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, DEVICE_ID)}>DID</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === DEVICE_ID && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, DEVICE_ID, ASC_ORDER)} />
                                                <img src={sort === DEVICE_ID && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, DEVICE_ID, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, SOFTWARE_VERSION)}>EOS Version</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === SOFTWARE_VERSION && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, SOFTWARE_VERSION, ASC_ORDER)} />
                                                <img src={sort === SOFTWARE_VERSION && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, SOFTWARE_VERSION, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, CREATE_TIME)}>Creation Time</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === CREATE_TIME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, CREATE_TIME, ASC_ORDER)} />
                                                <img src={sort === CREATE_TIME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, CREATE_TIME, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, USER)}>Initiated By</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === USER && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, USER, ASC_ORDER)} />
                                                <img src={sort === USER && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, USER, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                        <span className="backup-config-headers align-items-center">
                                            <span className="fleetDataTableSite default-config-dp-name font-wt-900" onClick={(event) => switchSorting(event, STATUS)}>Status</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === STATUS && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, STATUS, ASC_ORDER)} />
                                                <img src={sort === STATUS && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, STATUS, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    {!isReadOnlyUser && <TableCell className="fleetDataTable usage-fleetDataTable config-left-align">
                                    <span className="fleetDataTableSite default-config-dp-name font-wt-900">Actions</span>
                                    </TableCell>}
                                </TableRow>
                            </TableHead>
                            {0 != backupTableData?.length ? (
                                <TableBody className="tableBody usage-tableBody manual-backup-table">
                                    {
                                        backupTableData && backupTableData.map((row, i) =>
                                            <TableRow key={i} className="usageData-tabelRow config-backup-tabe-row">
                                                {
                                                    _.isEmpty(row.cloud_file_path)
                                                    ? <TableCell className="usagedata-tableCell config-left-align" >{row.config_name}</TableCell>
                                                    : <TableCell className="usagedata-tableCell config-left-align selected-config" onClick={() => handleDOwnloadConfig(row)}>{row.config_name}</TableCell>
                                                }
                                                <TableCell className="usagedata-tableCell config-left-align">{!row?.is_shared ? row.ou_name : null}</TableCell>
                                                <TableCell className="usagedata-tableCell config-left-align">{!row?.is_shared ? row.site_name : null}</TableCell>
                                                <TableCell className="usagedata-tableCell config-left-align">{!row?.is_shared ? row.device_id : null}</TableCell>
                                                <TableCell className="usagedata-tableCell config-left-align">{row.software_version}</TableCell>
                                                <TableCell className="usagedata-tableCell config-left-align">{convertDateTimeIntoTimezone(row.create_time, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</TableCell>
                                                <Tooltip disableHoverListener={_.isEmpty(row.user)} title={<span className="font-size-12px">{row.user}</span>}>
                                                    <TableCell className="usagedata-tableCell config-left-align short-text-action-initiated-by">{row.user}</TableCell>
                                                </Tooltip>
                                                <Tooltip disableHoverListener={_.isEmpty(row.failure_reason)} title={<span className="font-size-12px">{row.failure_reason}</span>}>
                                                    <TableCell className="usagedata-tableCell config-left-align manual-backup-status">{row.status}</TableCell>
                                                </Tooltip>
                                                {!isReadOnlyUser && <TableCell className="usagedata-tableCell config-left-align actions">
                                                    {(row?.is_shared == false) &&<img src={DeleteIcon} title="Delete configuration" 
                                                        onClick={() => {
                                                            setConfirmDialog({
                                                                isOpen: true,
                                                                title: CONFIRM_DIALOG_TITLE,
                                                                subTitle: `Confirm to delete the configuration: ${row.config_name} ?`,
                                                                onConfirm: () => {
                                                                    DeleteManualBackipConfig(row)
                                                                },
                                                            })
                                                        }}
                                                    />}
                                                    {(row?.is_shared && selectedOrg?.id == userOu?.id) && <img src={DeleteIcon} title="Delete All Shares"
                                                        onClick={() => {
                                                            setConfirmDialog({
                                                                isOpen: true,
                                                                title: CONFIRM_DIALOG_TITLE,
                                                                subTitle: (
                                                                    <>
                                                                        Confirm to delete all shared configurations for{" "}
                                                                        <strong>{row?.config_name}</strong> ?
                                                                        <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                                                                            Note: If the config name is set as the default config, it will also be removed when deleted.
                                                                        </div>
                                                                    </>
                                                                ),
                                                                onConfirm: () => {
                                                                    const payload = {
                                                                        share_id: row?.share_id,
                                                                        ou_id: selectedOrg?.id
                                                                    }
                                                                    deleteSharedConfigData(row?.id, payload)
                                                                },
                                                            })
                                                        }}
                                                    />}
                                                    {((!(row?.is_shared && selectedOrg?.id == userOu?.id)) || (row?.is_shared && selectedOrg?.id == userOu?.id)) && <ShareIcon onClick={() => {clickConfigShareIcon(row, 'share'); setActionType('Share')}} cursor="pointer" />}
                                                    {(row?.is_shared && selectedOrg?.id == userOu?.id) && <img src={edit} alt="" onClick={() => {clickConfigShareIcon(row, 'edit'); setActionType('Edit')}} />}
                                                </TableCell>}
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={9} className="noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                   
                </Grid>
                <AddEditInterfaceModal
                    open={shareConfigDialog}
                    onClose={() => { setShareConfigDialog(false); setCustomName(''); setIsDataLoaded(false); }}
                    onSave={hanldeSaveShareConfig}
                    saveText={actionType == 'Edit' ? 'Update' : 'Share'}
                    disableSave={handleSaveDisabled()}
                    title={actionType == 'Edit' ? 'Update Config Name' : `Share ${selectedConfig?.config_name}`}
                    layout={[
                        {
                            columns: [
                                ...(false ? [{
                                    component: (
                                        <img src={DeleteIcon} title="Delete All Shares" 
                                            onClick={() => {
                                                setConfirmDialog({
                                                    isOpen: true,
                                                    title: CONFIRM_DIALOG_TITLE,
                                                    subTitle: (
                                                        <>
                                                            Confirm to delete all shared configurations for{" "}
                                                            <strong>{originalCustomName}</strong> ?
                                                            <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                                                                Note: If the config name is set as the default config, it will also be removed when deleted.
                                                            </div>
                                                        </>
                                                    ),
                                                    onConfirm: () => {
                                                        const payload = {
                                                            share_id: selectedConfig?.share_id,
                                                            ou_id: selectedOrg?.id
                                                        }
                                                        deleteSharedConfigData(selectedConfig?.id, payload)
                                                    },
                                                })
                                            }}
                                            style={{ position: 'absolute', cursor: 'pointer', right: '15px' }}
                                        />
                                    ),
                                    gridSize: 12,
                                }] : []),
                                ...(actionType != 'Edit' ? [{
                                    component: (
                                        <LabelValueDisplay
                                            label="Shared Config Organizations"
                                            customComponent={
                                                <div style={{ width: '100%', maxWidth: '438px' }}>
                                                  {isDataLoaded ? <Org_Drop_down
                                                        key={orgDropdownKey}
                                                        setOu={handleOu}
                                                        className={'dp-dropdown-activity-filters'}
                                                        is_report_edit={isReportEdit}
                                                        deviceOu={userOu}
                                                        disableUserOuEdit={true}
                                                        disabledOuIds={[selectedConfig?.ou_id]}
                                                        // alreadySharedCount={alreadySharedOuIds?.filter(id => id !== userOu?.id && id !== selectedConfig?.ou_id).length}
                                                    /> :
                                                    <Org_Drop_down
                                                        key={orgDropdownKey}
                                                        setOu={handleOu}
                                                        className={'dp-dropdown-activity-filters'}
                                                        is_report_edit={isReportEdit}
                                                        deviceOu={userOu}
                                                        disableUserOuEdit={true}
                                                        disabledOuIds={[selectedConfig?.ou_id]}
                                                        // alreadySharedCount={alreadySharedOuIds?.filter(id => id !== userOu?.id && id !== selectedConfig?.ou_id).length}
                                                    />
                                                    }
                                                </div>
                                            }
                                        />
                                    ),
                                    gridSize: 12,
                                }] : []),
                                {
                                    component: (
                                        <LabelValueDisplay
                                            label="Config Name"
                                            isInput
                                            value={customName}
                                            onChange={(e) => setCustomName(e.target.value)}
                                            placeholder="Enter Config Name"
                                            width={315}
                                        />
                                    ),
                                    gridSize: 12,
                                }
                            ]
                        }
                    ]}
                />
                <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
            </Grid>
            {setBackupConfigDataLoading || setCreateShareConfigLoading || setSharedConfigPerConfigLoading || setUpdateSharedConfigLoading || setDeleteSharedConfigLoading ? (
                    <CustomLoader
                      showLoader={true}
                      loadingText={"Please wait..."}
                    />
                  ) : null}
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    isReadOnlyUser: state?.authReducer?.isReadOnlyUser,
    setCreateShareConfigLoading: state?.authReducer?.setCreateShareConfigLoading,
    createShareConfig: state?.authReducer?.createShareConfig,
    getSharedConfigPerConfig: state?.authReducer?.getSharedConfigPerConfig,
    setSharedConfigPerConfigLoading: state?.authReducer?.setSharedConfigPerConfigLoading,
    setUpdateSharedConfigLoading: state?.authReducer?.setUpdateSharedConfigLoading,
    getUpdateSharedConfig: state?.authReducer?.getUpdateSharedConfig,
    getDeleteSharedConfig: state?.authReducer?.getDeleteSharedConfig,
    setDeleteSharedConfigLoading: state?.authReducer?.setDeleteSharedConfigLoading,
    setBackupConfigDataLoading: state?.authReducer?.setBackupConfigDataLoading,
    selectedOrg: state?.authReducer?.selectedOu,
});

export default withRouter(
    connect(mapStateToProps, {
        backupConfigData, inventoryDownloadConfig, clearInventoryConfigDownload, getInventoryWarehouseVesselList, deleteManualBackupConfig, downloadAsCSV, createShareConfigData, getSharedConfigPerConfigData, updateSharedConfigData, deleteSharedConfigData
    })(ManualBackupConfig)
);